<div class="error-screen">
  <app-modal-dialog id="error-dialog" [title]="errorTitle" (closed)="this.onCloseDialog()">
    <div class="modal-dialog-static">{{errorText}}</div>
    <div class="modal-dialog-buttons">
      <button class="primary-button" (click)="this.closeDialog()">Close</button>
    </div>
  </app-modal-dialog>
</div>
